'use client';

import { useEffect, useRef } from 'react';
import { gtmPush } from '@/utils/tracking/gtm';
import { GTM } from '@/utils/tracking/gtm/constants';
import { useStore } from '@/store/store';
import { useSnowplowUm } from '@/tracking/snowplow';
import { getSnowplowProperties } from '@/tracking/snowplow/utils';
import { buildPageEventProps } from '@/tracking/amplitude/events/general/page-viewed';
import { useTrackingContext } from '@/tracking/context/use-tracking-context';
import { useGlobalContext } from '@/store/contexts/global-context';

// TODO: come back to this asap
export const PageViewTracker: React.FC = () => {
    const trackingContext = useTrackingContext();
    const pathname = trackingContext.route.pathname;
    const previousPathname = useRef<string | null>(null);
    const brand = process.env.BRAND || 'unknown';
    const userPlayableBalance = useStore((state) => state.userContext.balance);
    const { trackPageView } = useSnowplowUm();
    const { sendEvent, initialized: isTrackingReady } = useStore((state) => state.tracking);
    const { region } = useGlobalContext();

    useEffect(() => {
        if (pathname !== previousPathname.current) {
            previousPathname.current = pathname;

            const pagePath = pathname.split('?')[0];

            //TODO find a way to send events for GTM and Snowplow with tracking manager
            gtmPush({
                event: GTM.EVENTS.SCREEN_LOAD,
                pagePath,
                loginStatus: trackingContext.user.loginStatus,
                siteVersion: trackingContext.platform.siteVersion,
                fdAccountId: trackingContext.user.userIdCookie || trackingContext.user.accountId || undefined,
                jurisdiction: trackingContext.user.jurisdiction?.toUpperCase() || undefined,
                brand: brand
            });

            const eventProps = getSnowplowProperties({
                balance: userPlayableBalance,
                isLoggedIn: trackingContext.user.isLoggedIn,
                region,
                isMobile: trackingContext.platform.isMobile,
                isAndroidWrapper: trackingContext.platform.isAndroidWrapper,
                isIosWrapper: trackingContext.platform.isIosWrapper,
                pathname: trackingContext.route.pagePath
            });

            trackPageView(eventProps);
        }
    }, [
        pathname,
        brand,
        userPlayableBalance,
        trackPageView,
        trackingContext.user.loginStatus,
        trackingContext.user.isLoggedIn,
        trackingContext.user.jurisdiction,
        trackingContext.user.userIdCookie,
        trackingContext.user.accountId,
        trackingContext.platform.siteVersion,
        trackingContext.platform.isMobile,
        trackingContext.platform.isAndroidWrapper,
        trackingContext.platform.isIosWrapper,
        trackingContext.route.pagePath
    ]);

    useEffect(() => {
        if (!isTrackingReady) {
            return;
        }

        const pageEventProps = buildPageEventProps(pathname);
        if (!pageEventProps?.event) {
            return;
        }
        sendEvent([{ destination: 'amplitude', eventProps: pageEventProps }]);
    }, [pathname, sendEvent, isTrackingReady]);

    return null;
};
